<template>
  <MarketingPageShell>
    <template #hero>
      <span class="hero-badge">关于笔芯科研</span>
      <h1>{{ pageSeo.h1 }}</h1>
      <p>
        笔芯科研 专注学术与办公文本场景，提供降重、降 AIGC、检测与文档工具，
        帮助用户在合规前提下提升原创表达与写作效率。
      </p>
    </template>

    <div class="intro-card">
      <p>
        无论是学术文章定稿、期刊投稿还是日常文稿优化，您都可以在一个账户内完成多种处理任务。
        我们采用统一字数点数计费，规则透明，支持微信登录，开箱即用。
      </p>
    </div>

    <h2 class="section-title">我们提供什么</h2>
    <div class="feature-grid">
      <div v-for="item in features" :key="item.title" class="feature-card">
        <div class="feature-icon"><i :class="item.icon"></i></div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.desc }}</p>
      </div>
    </div>

    <h2 class="section-title">为什么选择我们</h2>
    <div class="value-grid">
      <div v-for="item in values" :key="item.title" class="value-card">
        <i :class="item.icon"></i>
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <div class="cta-box">
      <h2>准备好开始了吗？</h2>
      <p>注册即送体验字数，登录后即可提交处理任务</p>
      <router-link to="/workbench" class="btn-primary">
        进入工作台 <i class="bi bi-arrow-right"></i>
      </router-link>
    </div>
  </MarketingPageShell>
</template>

<script>
import MarketingPageShell from '@/components/portal/MarketingPageShell.vue'
import { resolvePageSeo } from '@/constants/siteSeo'

export default {
  name: 'PortalAboutView',
  components: { MarketingPageShell },
  computed: {
    pageSeo() {
      return resolvePageSeo('/about')
    }
  },
  data() {
    return {
      features: [
        { icon: 'bi bi-arrow-repeat', title: '降重降AI', desc: '降重复率、降AIGC、双降与学术润色，适配主流查重平台。' },
        { icon: 'bi bi-shield-check', title: 'AIGC 检测', desc: '提交文本进行AI生成风险检测，辅助自查与修改。' },
        { icon: 'bi bi-journal-bookmark', title: '文献与文档', desc: '文献检索、Word瘦身、图片去AIGC等扩展工具。' },
        { icon: 'bi bi-easel', title: 'PPT 辅助', desc: 'PPT 设计相关能力，提升演示文稿制作效率。' }
      ],
      values: [
        { icon: 'bi bi-coin', title: '透明计费', desc: '按字数扣点，套餐永久有效，消耗规则清晰可查。' },
        { icon: 'bi bi-shield-lock', title: '安全传输', desc: '内容加密传输，仅用于完成您提交的处理任务。' },
        { icon: 'bi bi-wechat', title: '微信登录', desc: '扫码即可使用，无需记忆额外密码。' }
      ]
    }
  }
}
</script>

<style scoped>
.hero-badge {
  display: inline-block;
  margin-bottom: 12px;
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--primary-light, #e3f2fd);
  color: var(--primary, #1976d2);
  font-size: 12px;
  font-weight: 600;
}

h1 {
  margin: 0 0 12px;
  font-size: clamp(30px, 4vw, 40px);
  font-weight: 700;
  line-height: 1.2;
}

.page-hero p {
  margin: 0;
  max-width: 680px;
  font-size: 16px;
  line-height: 1.75;
  color: var(--text-secondary, #666);
}

.intro-card {
  margin-bottom: 40px;
  padding: 24px 28px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f3f8ff 0%, #f3f6ff 100%);
  border: 1px solid rgba(25, 118, 210, 0.12);
}

.intro-card p {
  margin: 0;
  font-size: 16px;
  line-height: 1.85;
  color: #4b5563;
}

.section-title {
  margin: 0 0 20px;
  font-size: 22px;
  font-weight: 600;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-bottom: 48px;
}

.feature-card {
  padding: 22px 18px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #dbeafe;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.feature-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(25, 118, 210, 0.08);
}

.feature-icon {
  width: 44px;
  height: 44px;
  margin-bottom: 14px;
  border-radius: 12px;
  background: var(--primary-light, #e3f2fd);
  color: var(--primary, #1976d2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.feature-card h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.feature-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-secondary, #666);
}

.value-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 48px;
}

.value-card {
  display: flex;
  gap: 14px;
  padding: 20px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dbeafe;
}

.value-card > i {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f9fafb;
  color: var(--primary, #1976d2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.value-card h3 {
  margin: 0 0 6px;
  font-size: 15px;
}

.value-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary, #666);
}

.cta-box {
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  color: #fff;
}

.cta-box h2 {
  margin: 0 0 10px;
  font-size: 26px;
}

.cta-box p {
  margin: 0 0 22px;
  opacity: 0.92;
}

.cta-box .btn-primary {
  background: #fff;
  color: var(--primary, #1976d2);
  box-shadow: none;
}

.cta-box .btn-primary:hover {
  background: #f8fafc;
}

@media (max-width: 960px) {
  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .value-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }

  .cta-box {
    padding: 32px 24px;
  }
}
</style>
